const utils = {

};

utils.initMeiQia = function () {
    (function (a, b, c, d, e, j, s) {
        // eslint-disable-line
        a[d] =
            a[d] ||
            function () {
                (a[d].a = a[d].a || []).push(arguments);
            };
        (j = b.createElement(c)), (s = b.getElementsByTagName(c)[0]);
        j.async = true;
        j.charset = "UTF-8";
        j.src = "https://visitor-static.meiqia.com/fe-widget-visitor/loader.js";
        s.parentNode.insertBefore(j, s);
    })(window, document, "script", "_MEIQIA");
}

utils.userIdIsEmpty = function (ppid) {
    return ppid === undefined || ppid === null || ppid === "" || ppid === "undefined" || ppid === "null" || ppid === "0";
}

export default utils;